import React, { useEffect, useState } from "react";

import {
  DataGrid,
  GridActionsCellItem,
  GridColDef,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import "./styles.scss";
import { ArticleRounded, EditRounded } from "@mui/icons-material";
import { PartnershipType } from "../../types/genericType";
import { getPartnershipById } from "../../services/partnershipService";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Stack,
} from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";

type PartnershipsProps = {
  partnerships: Array<PartnershipType>;
  setSelectedPartnership: Function;
  setShowDetails: Function;
  setOpenEditDrawer: Function;
};

const PartnershipsTable = (props: PartnershipsProps) => {
  const {
    partnerships,
    setSelectedPartnership,
    setShowDetails,
    setOpenEditDrawer,
  } = props;
  const [filteredRows, setFilteredRows] = useState(partnerships);
  const [seletedStatus, setSelectedStatus] = useState("active");

  const updateSelectedPartnership = (id: number, type: string) => {
    getPartnershipById(id)
      .then((res) => {
        setSelectedPartnership(res);
        type === "edit" && setOpenEditDrawer(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    const filteredData = partnerships.filter((row) => {
      const matchesStatus =
        seletedStatus === "*" ||
        (row.isActive ? "active" : "inactive") === seletedStatus;

      return matchesStatus;
    });

    setFilteredRows(filteredData);
  }, [partnerships, seletedStatus]);

  const columns: GridColDef[] = React.useMemo<GridColDef[]>(
    () => [
      {
        field: "name",
        headerName: "Name",
        hideable: false,
        width: 256,
        headerClassName: "header-datagrid",
      },
      {
        field: "description",
        headerName: "Description",
        width: 256,
        sortable: false,
        headerClassName: "header-datagrid",
      },
      {
        field: "status",
        headerName: "Status",
        width: 120,
        headerClassName: "header-datagrid",
        valueGetter: (params: GridValueGetterParams) =>
          `${params.row.isActive ? "Active" : "Inactive"}`,
      },
      {
        field: "view",
        headerName: "View",
        sortable: false,
        width: 70,
        align: "center",
        headerAlign: "center",
        headerClassName: "header-datagrid",
        type: "actions",
        getActions: (params: GridValueGetterParams) => [
          <GridActionsCellItem
            icon={<ArticleRounded className="view-icon" />}
            label="Details"
            onClick={() => {
              updateSelectedPartnership(params.row.id, "view");
              setShowDetails(true);
            }}
          />,
        ],
      },
      {
        field: "edit",
        headerName: "Edit",
        sortable: false,
        width: 50,
        align: "center",
        headerAlign: "center",
        headerClassName: "header-datagrid",
        type: "actions",
        getActions: (params: GridValueGetterParams) => [
          <GridActionsCellItem
            icon={<EditRounded className="edit-icon" />}
            label="Details"
            onClick={() => {
              updateSelectedPartnership(params.row.id, "edit");
            }}
          />,
        ],
      },
    ],
    []
  );

  return (
    <div className="partnership-table">
      <Stack
        spacing={2}
        direction="row"
        className="search-filter"
        padding="20px"
      >
        <FormControl style={{ width: 200 }}>
          <InputLabel id="status_label" shrink>
            Status
          </InputLabel>

          <Select
            labelId="status_label"
            label="Status"
            value={seletedStatus}
            onChange={(event: SelectChangeEvent) =>
              setSelectedStatus(event.target.value as string)
            }
            sx={{
              height: "40px", // Adjust this value as needed
              padding: "0 14px", // Adjust this value as needed
              "& .MuiSelect-select": {
                padding: "0px 0", // Adjust this value as needed
              },
            }}
          >
            <MenuItem value="*">All</MenuItem>
            <MenuItem value="active">Active</MenuItem>
            <MenuItem value="inactive">Inactive</MenuItem>
          </Select>
        </FormControl>
      </Stack>
      <DataGrid
        rows={filteredRows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 },
          },
        }}
        pageSizeOptions={[10, 20, 30, 40, 50]}
        rowSelection={false}
        className="datagrid"
      />
    </div>
  );
};

export default PartnershipsTable;
